import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { RotateLoader } from "react-spinners";
import { LoadingType } from "@/types/Loading";
var Loading = function (_a) {
    var type = _a.type, color = _a.color;
    var size;
    var className;
    if (type === LoadingType.Large) {
        size = "15px";
        className = "flex items-center justify-center h-screen";
    }
    else if (type === LoadingType.Medium) {
        size = "10px";
        className = "flex flex-1 items-center justify-center h-3/4 w-full";
    }
    else {
        size = "5px";
        className = "flex items-center justify-center";
    }
    return (_jsx("div", { className: className, children: _jsx(RotateLoader, { color: color, size: size }) }));
};
export default Loading;
